angular.module('edxResources')
  .component('edxResourcesTab', {
    bindings: {
      data: '<'
    },
    templateUrl: '/resources/components/edx-resources/edx-resources-tab.component.html',
    controllerAs: 'vm',
    controller: function() {
      var vm = this;

      vm.sectionId = '';
      vm.name = '';
      vm.header = '';
      vm.message = '';
      vm.whatsIncluded = null;
      vm.relatedArticles = null;
      vm.modules = null;
      vm.analyticsCategory = '';

      vm.$onInit = function() {
        vm.sectionId = vm.data.sectionId;
        vm.name = vm.data.name;
        vm.header = vm.data.header;
        vm.message = vm.data.message;
        vm.whatsIncluded = vm.data.whatsIncluded;
        vm.relatedArticles = vm.data.relatedArticles;
        vm.modules = vm.data.modules;
        vm.analyticsCategory = vm.data.analyticsCategory;
      };
    }
  });
